var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$slots.actions)?_c('div',{staticClass:"page-header page-header--actions-only"},[(_vm.$slots.actions)?_c('div',{staticClass:"page-header__actions"},[_vm._t("actions")],2):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }